import React from 'react';
import { BodyMediumRegular } from 'smoothie';

import {
    getCategoryDisplayString,
    sortCategories,
} from '../../../common/utils/billUtils';
import { BillCategory, BillCreationType } from '../../types/Bill';
import type { BillDetailsEditTypeProps } from '../edit/BillDetailsEditContainer';
import { SelectableRow } from './BillRows';

const BillEditCategory = ({ bill, onChange }: BillDetailsEditTypeProps) => {
    // Allow CC minimum category if:
    // 1. Creating a new bill (no creationType yet)
    // 2. Editing an existing manual bill
    const allowCreditCardMinimum =
        bill.creationType == null ||
        bill.creationType === BillCreationType.MANUAL ||
        bill.creationType === BillCreationType.MONEY_MAPPER;

    return (
        <>
            {Object.values(BillCategory)
                .filter((category) => {
                    // Filter out CC minimum for non-manual bills
                    if (category === BillCategory.CREDIT_CARD_MINIMUM) {
                        return allowCreditCardMinimum;
                    }
                    return true;
                })
                .sort(sortCategories)
                .map((category, i) => (
                    <SelectableRow
                        key={i}
                        isSelected={category === bill.category}
                        isMultiSelect={false}
                        isFirstRow={i === 0}
                        onSelect={() => {
                            const newBill = { ...bill, category };
                            onChange(newBill);
                        }}
                        rowContentComponent={
                            <BodyMediumRegular padding={8}>
                                {getCategoryDisplayString(category)}
                            </BodyMediumRegular>
                        }
                    />
                ))}
        </>
    );
};

export default BillEditCategory;
